"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _color = require("../tokens/color");
var _noop2 = _interopRequireDefault(require("lodash-es/noop"));
var _commonHelper = require("../helpers/commonHelper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MenuItem = function MenuItem(props) {
  var _props$leftIcon = props.leftIcon,
    leftIcon = _props$leftIcon === void 0 ? null : _props$leftIcon,
    _props$leftNode = props.leftNode,
    leftNode = _props$leftNode === void 0 ? null : _props$leftNode,
    _props$centered = props.centered,
    centered = _props$centered === void 0 ? false : _props$centered,
    _props$value = props.value,
    value = _props$value === void 0 ? "" : _props$value,
    _props$label = props.label,
    label = _props$label === void 0 ? "" : _props$label,
    _props$desc = props.desc,
    desc = _props$desc === void 0 ? "" : _props$desc,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$selected = props.selected,
    selected = _props$selected === void 0 ? false : _props$selected,
    _props$isCompact = props.isCompact,
    isCompact = _props$isCompact === void 0 ? false : _props$isCompact,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? "1.8rem" : _props$fontSize,
    _props$fontWeight = props.fontWeight,
    fontWeight = _props$fontWeight === void 0 ? "300" : _props$fontWeight,
    _props$bold = props.bold,
    bold = _props$bold === void 0 ? "" : _props$bold,
    _props$id = props.id,
    id = _props$id === void 0 ? "" : _props$id,
    _props$keySelected = props.keySelected,
    keySelected = _props$keySelected === void 0 ? false : _props$keySelected,
    _props$_passClick = props._passClick,
    _passClick = _props$_passClick === void 0 ? _noop2["default"] : _props$_passClick,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    _props$noMarginTop = props.noMarginTop,
    noMarginTop = _props$noMarginTop === void 0 ? false : _props$noMarginTop,
    _props$isMultiliner = props.isMultiliner,
    isMultiliner = _props$isMultiliner === void 0 ? false : _props$isMultiliner,
    _props$isVisible = props.isVisible,
    isVisible = _props$isVisible === void 0 ? true : _props$isVisible,
    _props$enableClick = props.enableClick,
    enableClick = _props$enableClick === void 0 ? false : _props$enableClick;
  var handleClick = function handleClick(value, label, enableClick) {
    return function (e) {
      !enableClick && e.preventDefault();
      !disabled && _passClick(value, label);
    };
  };
  return /*#__PURE__*/_react["default"].createElement(MenuItem.Wrapper, {
    className: className,
    onClick: handleClick(value, label, enableClick),
    isSelected: selected,
    id: selected ? id + "-selected" : id + "-" + value,
    "aria-label": label,
    isKeySelected: keySelected,
    isCompact: isCompact,
    disabled: disabled,
    isVisible: isVisible,
    enableClick: enableClick
  }, /*#__PURE__*/_react["default"].createElement(LeftSection, {
    hasDesc: !!desc.length,
    centered: centered
  }, leftIcon && (0, _commonHelper.cloneChildren)(leftIcon, {
    size: 16,
    color: disabled ? _color.grey.z400 : _color.grey.z800
  }), leftNode && (0, _commonHelper.cloneChildren)(leftNode), /*#__PURE__*/_react["default"].createElement(Span, {
    isSelected: selected,
    noMarginTop: noMarginTop,
    hasLeftIcon: !!leftIcon || !!leftNode,
    disabled: disabled,
    fontSize: fontSize,
    fontWeight: fontWeight,
    isMultiliner: isMultiliner,
    centered: centered
  }, getBoldLabel(label, bold))), !!desc && /*#__PURE__*/_react["default"].createElement(DescSpan, {
    isKeySelected: keySelected
  }, desc));
};
var getBoldLabel = function getBoldLabel(label, str) {
  if (!str) return label;
  var pattern = new RegExp(str, "i");
  var match = label.match(pattern);
  label = label.replace(pattern, "__anchor__");
  var splitElem = label.split("__anchor__");
  return splitElem.map(function (part, i) {
    var boldElem = i != splitElem.length - 1 ? /*#__PURE__*/_react["default"].createElement(Bold, null, match) : null;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: part
    }, part, boldElem);
  });
};
var Bold = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  componentId: "sc-10vdmo9-0"
})(["font-weight:500;font-size:inherit;color:", ";"], _color.black);
MenuItem.propTypes = {
  leftIcon: _propTypes["default"].node,
  leftNode: _propTypes["default"].node,
  centered: _propTypes["default"].bool,
  text: _propTypes["default"].string,
  label: _propTypes["default"].string,
  desc: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  disabled: _propTypes["default"].bool,
  selected: _propTypes["default"].bool,
  bold: _propTypes["default"].string,
  isVisible: _propTypes["default"].bool,
  keySelected: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  _passClick: _propTypes["default"].func,
  isCompact: _propTypes["default"].bool,
  toRight: _propTypes["default"].bool,
  fontSize: _propTypes["default"].string,
  fontWeight: _propTypes["default"].string,
  className: _propTypes["default"].string,
  noMarginTop: _propTypes["default"].bool,
  isMultiliner: _propTypes["default"].bool
};
var getPadding = function getPadding(props) {
  if (props.enableClick) {
    return "0rem 1.5rem";
  }
  if (props.isCompact) {
    return "1rem 1rem";
  }
  return "1rem 2rem";
};
var DescSpan = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  componentId: "sc-10vdmo9-1"
})(["font-size:1.5rem;color:", ";white-space:nowrap;margin-left:2rem;overflow:hidden;text-overflow:ellipsis;font-weight:300;"], function (props) {
  return props.isKeySelected ? _color.grey.z800 : _color.grey.z400;
});
var LeftSection = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  componentId: "sc-10vdmo9-2"
})(["display:flex;align-items:", ";max-width:", ";"], function (_ref) {
  var centered = _ref.centered;
  return centered ? "center" : "unset";
}, function (props) {
  return props.hasDesc ? "65%" : "100%";
});
var Span = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  componentId: "sc-10vdmo9-3"
})(["margin-left:", ";margin-top:", ";font-size:", ";font-weight:", ";color:", ";align-items:", ";justify-content:space-between;", ";text-align:left;"], function (props) {
  return props.hasLeftIcon ? "1rem" : "0";
}, function (_ref2) {
  var noMarginTop = _ref2.noMarginTop;
  return noMarginTop ? 0 : "0.3rem";
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.disabled ? _color.grey.z400 : _color.grey.z800;
}, function (_ref3) {
  var centered = _ref3.centered;
  return centered ? "center" : "unset";
}, function (_ref4) {
  var isMultiliner = _ref4.isMultiliner;
  return !isMultiliner && (0, _styledComponents.css)(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
});
MenuItem.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-10vdmo9-4"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;padding:", ";cursor:", ";display:", ";background-color:", ";", ""], function (props) {
  return getPadding(props);
}, function (props) {
  return props.disabled ? "initial" : "pointer";
}, function (props) {
  return props.isVisible ? "block" : "none";
}, function (props) {
  return props.isKeySelected ? _color.grey.z95 : props.isSelected ? "#E9F2FC" : "initial";
}, function (props) {
  return !props.disabled && (0, _styledComponents.css)(["&:hover{background-color:", ";}&:hover > span{color:", ";}"], _color.grey.z95, _color.grey.z800);
});
var _default = exports["default"] = MenuItem;